export default __webpack_public_path__ + "static/media/user.36a0a337.svg";